import PostsSerializer from './base';

export default class FeedEntry extends PostsSerializer {
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    // Multi-word entity types are returned with a camelCase key, but
    // the models are defined as lowercase.  Flip it so they're processed.
    if (payload.communityNotices) {
      payload.communitynotices = payload.communityNotices;
      delete payload.communityNotices;
    }
    if (payload.staffNotices) {
      payload.staffnotices = payload.staffNotices;
      delete payload.staffNotices;
    }
    if (payload.attendanceNotes) {
      payload.attendancenotes = payload.attendanceNotes;
      delete payload.attendanceNotes;
    }
    if (payload.studentNotices) {
      payload.studentnotices = payload.studentNotices;
      delete payload.studentNotices;
    }
    // TODO: Add Global Notices, when we implement/use them.

    return super.normalizeResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    );
  }
}
